module.exports = __webpack_public_path__ + "img/chat.5a248a02.svg";